
import "./customImage.css";
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const CustomImage = ({ src, alt, imageName }) => {

    return (
        <>
            <TransformWrapper>
                <TransformComponent>
                    <img src={src} alt={imageName} style={{ width: "100%", height: "100%", paddingBottom: "20px" }} />
                </TransformComponent>
            </TransformWrapper>
        </>
    )
}

export default CustomImage;

